"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var spacing = require("@headspace/hs-web-style-guide/dist/spacing");

var utils = require("@headspace/hs-web-style-guide/dist/utils");

function FooterListContainer(props) {
  var title = props.title,
      children = props.children;
  return React.createElement("div", null, React.createElement("h4", __assign({}, spacing.default.marginBottomSmall), title), React.createElement("ul", __assign({}, hs_web_style_guide_1.css(utils.default.listStyleTypeNone), spacing.default.paddingLeftNone), children));
}

exports.FooterListContainer = FooterListContainer;